// import qs from 'qs';
import axios from "axios";
import { showNotify } from "vant";
import "vant/es/notify/style";
import router from "../router";
let https = 'https://front.api.huanyouhudong.com';//线上
// let https = 'http://192.168.110.11:2000';//本地
// let https = 'https://xhtest.iepose.cn';//穿透
// let https = '';

const http = axios.create({
  timeout: 30000,
  withCredentials: true,
});
// ========== 请求拦截器：统一注入公共头 + 登录头 ==========
http.interceptors.request.use(
  (config) => {
    const read = (k) => localStorage.getItem(k) || ''; // ★ 防 "null" 头
    const token = read("offUserToken");

    const headers = {
      'appVersion': '1.0.5',                       // 公共头只写一处
      'sourceType': read("sourceType"),
      'deviceType': read("deviceType"),
    };

    if (token) {                                   // 登录后追加用户头
      Object.assign(headers, {
        'offUserToken': token,
        'offUserId': read("offUserId"),
        'gameUserToken': read("gameUserToken"),
        'gameUserId': read("gameUserId"),
      });
    }

    Object.assign(config.headers, headers);
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      if (response.data.status == 13 || response.data.status == 14) {
        localStorage.removeItem("gameUserToken");
        localStorage.removeItem("gameUserId");
        localStorage.removeItem("offUserToken");
        localStorage.removeItem("offUserId");
        showNotify({
          type: "warning",
          message: "Token 无效，请重新登录",
          duration: 2 * 1000,
        });
        setTimeout(() => {
          router.push({ path: "/H5/homeOpen" }); // 跳转登录页
        }, 1000); // 1000毫秒 = 1秒
      }
      return response.data;
    } else {
      return Promise.reject(response);
    }
  },
  (err) => {
    showNotify({
      message: err.message || "error",
      type: "warning",
      duration: 5 * 1000,
    });
    return Promise.reject(err);
  }
);
// ========== 对外请求方法 ==========
export const request = (url, params, stringify = true, type = "post") => {
  if (type == "post") {
    // 强制以 JSON 发送的接口，加到这里
    const jsonApiList = ["/common/v1/order/query"];
    if (jsonApiList.includes(url)) {
      return http.post(https + url, params, {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      });
    }
    return http.post(https + url, params, { stringify });
  } else {
    return http.get(https + url, params, { stringify });
  }
};
